<!--
@component
Small "Beta" superscript tag, placed next to a label to mark a feature as beta.
-->

<sup class="beta-tag">Beta</sup>

<style>
	.beta-tag {
		display: inline-block;
		font-size: 0.875em;
		color: var(--color-green-500);
		font-style: italic;
	}
</style>
